export enum LoadingState {
    IDLE = 'idle',
    LOADING = 'loading',
    COMPLETED = 'completed',
    FAILED = 'failed'
}
